import { useContext } from 'react';
import { FinancialStatusContext } from './context/financial-status-context';

export default function MobileProgressIndicator() {
	const financialContext = useContext(FinancialStatusContext);
	const totalSteps = Object.keys(financialContext.jsonData).length;

	return (
		<div className="bg-UC-blue-100 min-w-20 whitespace-nowrap rounded-md p-3 text-lg text-gray-500">
			{financialContext.currentStep + 1} / {totalSteps}
		</div>
	);
}
